import { useUserStore } from '@/pinia/user'
import { useCouponDialog } from './useCouponDialog'
import { metaPixelTrack } from '@/utils/utils'
import { useSearchUrl } from '@/hooks/useSearchUrl'

export const useLogin = () => {
  const route = useRoute()
  const router = useRouter()
  const user = useUserStore()
  const { source } = useSearchUrl()
  const { showCouponDialog } = useCouponDialog()
  const store = useStore()

  const login = async (params) => {
    const data = await user.login({
      registerChannel: source.value ?? 2,
      ...params
    })

    // 给新用户展示满减券弹窗
    if (data?.newUser) {
      showCouponDialog()
      /**
       * Meta Pixel 埋点：注册成功(非登录)
       */
      metaPixelTrack('PRS401', 'Lead', { currency: '$', value: 1 })
    }

    await store.dispatch('cart/updateCartCount')

    /**
     * 登录完成后需要清除掉 渠道信息 (如果有的话)
     */
    const query = Object.fromEntries(
      Object.entries(route.query).filter(([key]) => {
        return !key.startsWith('utm_') && key !== 'source'
      })
    )

    router.replace({
      path: route.path,
      params: route.params,
      query
    })

    return data
  }

  const logout = async () => {
    await user.logout()
    if (route.meta.auth) {
      router.replace({
        name: 'home'
      })
    }
  }

  return {
    login,
    logout
  }
}
